import { JsonRpc } from "eosjs";
import { ApisProvider, ExtinctionData } from "./dataProvider_Testnet";

const rpcJs = new JsonRpc(ApisProvider.bdProvider);

export const LoadAccountBalance = async (username) => {
  const dataWax = await rpcJs.get_currency_balance(
    "eosio.token",
    username,
    "WAX"
  );
  const bWax = Number.parseFloat(dataWax).toFixed(2);

  const dataOnyx = await rpcJs.get_currency_balance(
    "waxonyxtoken",
    username,
    "ONYX"
  );
  const bOnyx = Number.parseFloat(dataOnyx).toFixed(2);

  const dataNeo = await rpcJs.get_currency_balance(
    "waxonyxtoken",
    username,
    "NEO"
  );
  const bNeo = Number.parseFloat(dataNeo).toFixed(2);

  const dataChalce = await rpcJs.get_currency_balance(
    "waxonyxtoken",
    username,
    "CHAL"
  );
  const bChal = Number.parseFloat(dataChalce).toFixed(2);

  const balances = {
    bFullWax: dataWax[0],
    bShortWax: bWax,
    bFullOnyx: dataOnyx[0],
    bShortOnyx: bOnyx,
    bFullNeo: dataNeo[0],
    bShortNeo: bNeo,
    bFullChalce: dataChalce[0],
    bShortChalce: bChal
  };

  return balances;
};

export const LoadisScrap = async (username) => {
  const table = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.GEARS_CONTRACT,
    table: "scrapyard",
    scope: ExtinctionData.GEARS_CONTRACT,
    lower_bound: username,
    upper_bound: username
  });

  const { rows } = table;

  if (Number(rows.length) !== 0) {
    const result = rows[0];
    const x = {
      isReady: true,
      itemsQty: result.rewardsize
    };
    return x;
  } else {
    const x = {
      isReady: false,
      itemsQty: 0
    };
    return x;
  }
};

export const LoadAccountStakedMinerals = async (username) => {
  const table = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.GEARS_CONTRACT,
    table: "alchemist",
    scope: ExtinctionData.GEARS_CONTRACT,
    lower_bound: username,
    upper_bound: username
  });

  const { rows } = table;

  if (Number(rows.length) !== 0) {
    const result = rows[0];
    return result;
  } else {
    return 0;
  }
};

export const LoadPrices = async () => {
  const table = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: ExtinctionData.TABLE_INGAMEFEES
  });
  const { rows } = table;
  const inGameFeesData = rows[0];

  const table2 = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.GEARS_CONTRACT,
    scope: ExtinctionData.GEARS_CONTRACT,
    table: ExtinctionData.TABLE_REWARDFEES
  });
  const rows2 = table2.rows;
  const rewardFeesData = rows2[0];

  const tableCfees = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: ExtinctionData.TABLE_CREATORSFEES
  });

  const cFees = tableCfees.rows[0];

  const data = {
    craftsuitfee: inGameFeesData.craftsuitfee,
    craftwepfee: inGameFeesData.craftwepfee,
    repairfee: inGameFeesData.repairfee,
    deployfee: inGameFeesData.deployfee,
    slotfee: inGameFeesData.slotfee,
    trainkitfee: inGameFeesData.trainkitfee,
    traintime: inGameFeesData.traintime,
    crateSuit: inGameFeesData.suitcrate,
    crateWeapon: inGameFeesData.wepcrate,
    crateDouble: inGameFeesData.doublecrate,
    onSale: inGameFeesData.onsale,
    scrapfee: rewardFeesData.scrapfee,
    commonneo: rewardFeesData.commonneo,
    rareneo: rewardFeesData.rareneo,
    epicneo: rewardFeesData.epicneo,
    legenneo: rewardFeesData.legenneo,
    commonchal: rewardFeesData.commonchal,
    rarechal: rewardFeesData.rarechal,
    epicchal: rewardFeesData.epicchal,
    legenchal: rewardFeesData.legenchal,
    discSuit: cFees.suitcrate,
    discWep: cFees.wepcrate,
    discDouble: cFees.doublecrate
  };

  return data;
};

export const LoadBugTable = async (username) => {
  const table = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.GEARS_CONTRACT,
    table: "unboxpacks",
    scope: ExtinctionData.GEARS_CONTRACT,
    limit: 100
  });

  const { rows } = table;

  if (rows !== undefined) {
    const promise = await Promise.all(
      rows.map(async (i) => {
        let rbData = {
          unboxer: i.unboxer,
          bugBox: i.pack_asset_id
        };
        return rbData;
      })
    );

    const userbdata = await Promise.all(
      promise
        .filter((x) => x.unboxer === username)
        .map((x) => {
          let i = {
            user: x.unboxer,
            boxId: x.bugBox
          };
          return i;
        })
    );

    return userbdata;
  } else {
    return "no bugs";
  }
};

export const LoadWorkshopData = async (username) => {
  const tableSuit = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: ExtinctionData.TABLE_SUIT_WORKSHOP,
    lower_bound: username,
    upper_bound: username
  });
  const resultSuit = tableSuit.rows[0];

  const tableWeapon = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: ExtinctionData.TABLE_WEAPON_WORKSHOP,
    lower_bound: username,
    upper_bound: username
  });
  const resultWeapon = tableWeapon.rows[0];

  const result = {
    resultSuit,
    resultWeapon
  };

  return result;
};

export const LoadRadiationTable = async (username) => {
  const table = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: "radiation",
    lower_bound: username,
    upper_bound: username
  });

  const table2 = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: "radiation",
    index_position: 2,
    key_type: "name",
    upper_bound: username,
    lower_bound: username,
    reverse: true
  });

  const creatorsTable = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: "creators",
    index_position: 2,
    key_type: "name",
    lower_bound: username,
    upper_bound: username
  });

  const dataCreators = creatorsTable.rows[0];

  const { rows } = table;
  let data = table2.rows;
  const qty = table2.rows.length;
  if (Number(data.length) > 6) {
    data = [
      table2.rows[0],
      table2.rows[1],
      table2.rows[2],
      table2.rows[3],
      table2.rows[4],
      table2.rows[5]
    ];
  }

  if (Number(rows.length) !== 0) {
    let response = {};
    if (dataCreators !== undefined) {
      response = {
        status: true,
        points:
          Math.round((Number(rows[0].points) + Number.EPSILON) * 100) / 100,
        data: data,
        qty: qty,
        statusCreator: true,
        dataCreator: dataCreators
      };
    } else {
      response = {
        status: true,
        points:
          Math.round((Number(rows[0].points) + Number.EPSILON) * 100) / 100,
        data: data,
        qty: qty,
        statusCreator: false
      };
    }
    return response;
  } else {
    const response = {
      status: false
    };
    return response;
  }
};

export const LoadRewardExp = async (username) => {
  const templates = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: "templates"
  });

  const results = await rpcJs.get_table_rows({
    json: true,
    code: ExtinctionData.EXTINCTION_CONTRACT,
    scope: ExtinctionData.EXTINCTION_CONTRACT,
    table: "results",
    lower_bound: username,
    upper_bound: username
    /* lower_bound: 'sirpapalegba',
        upper_bound: 'sirpapalegba', */
  });

  const data_results = results.rows[0];
  const data_templates = templates.rows[0];

  if (data_results !== undefined) {
    let data = {
      result: data_results.template_id,
      templates: data_templates
    };

    return data;
  } else {
    let data = {
      result: undefined,
      templates: data_templates
    };

    return data;
  }
};
/* export const GetItemData = async(item_id) => {
    const api = `https://test.wax.api.atomicassets.io/atomicassets/v1/assets/${item_id}`;

    const response = await fetch(api, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
        }
    });
    const data = await response.json();
    const assetData = data.data;

    return assetData;
}

export const LoadBetaTester = async(username) => {
    const table = await rpcJs.get_table_rows({
        json: true,
        code: ExtinctionData.GEARS_CONTRACT,
        scope: ExtinctionData.GEARS_CONTRACT,
        table: ExtinctionData.TABLE_STARTERKIT,
        lower_bound: username,
        upper_bound: username,
    });
    const result = table.rows[0]
    
    return result;
} */
